
export enum GrowlType {

    INFO                = 'info',
    SUCCESS             = 'success',
    WARNING             = 'warning',
    ERROR               = 'error',

    AUTOMATION_APPLIED  = 'automationApplied',
    CLIENT_CREATED      = 'clientCreated',
    CUSTOMER_CREATED    = 'customerCreated',
    TASK_CREATED        = 'taskCreated',
    EVENT_CREATED       = 'eventCreated',
    CHAT_MESSAGE        = 'chatMessage',
    AUTOMATION_CREATED  = 'automationCreated',
    RATE_EXPERIENCE     = 'rateExperience',
    REMINDER_CREATED    = 'reminderCreated',
    CONNECTION_ERROR    = 'connectionError',

    ACCOUNT_CREATED     = 'account',
    CONTACT_CREATED     = 'contact',
}


export type Message = {
    id        ?: ID
    title     ?: string
    shortId   ?: ID
    type      ?: GrowlType
    chatId    ?: ID
    fromUserId?: ID
    message   ?: any
}
